"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

require("core-js/modules/es6.function.name");

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _axisLabelFormatterOptions = _interopRequireDefault(require("../label-formatters/axis-label-formatter-options"));

var _axisLabelFormatters = require("../label-formatters/axis-label-formatters");

var _styles = require("../styles");

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _defaultShortNumberFormatter = _interopRequireDefault(require("../label-formatters/default-short-number-formatter"));

var _highcharts = _interopRequireDefault(require("highcharts"));

var _heatmap = _interopRequireDefault(require("highcharts/modules/heatmap"));

var _logger = _interopRequireDefault(require("../logger"));

var _mwChartHeatmapClickOptions = _interopRequireDefault(require("./mw-chart-heatmap-click-options"));

var _getHeatmapGradientColorBuckets = require("./get-heatmap-gradient-color-buckets");

var _mwChartHeatmapLabelFormatterOptions = _interopRequireDefault(require("./mw-chart-heatmap-label-formatter-options"));

var _mwChartHeatmapOptions = _interopRequireDefault(require("./mw-chart-heatmap-options"));

var _mwChartHeatmapTooltipOptions = _interopRequireDefault(require("./mw-chart-heatmap-tooltip-options"));

var _seriesData = _interopRequireDefault(require("../series-data"));

(0, _heatmap.default)(_highcharts.default);

var DEFAULT_LEGEND_LABEL_FORMATTER = function DEFAULT_LEGEND_LABEL_FORMATTER(_ref) {
  var value = _ref.value;
  return (0, _defaultShortNumberFormatter.default)(value);
};

function addColorToChartData(options) {
  var seriesData = options.seriesData,
      colorBuckets = options.colorBuckets;
  var minVal = colorBuckets[0].min;
  var stepSize = colorBuckets[1].min - colorBuckets[0].min;

  if (stepSize < 0) {
    throw new Error("the stepSize can't be lower than '0'. Provided value: ".concat(JSON.stringify(stepSize), " "));
  }

  var newSeriesData = seriesData.map(function (point) {
    var bucketIndex = parseInt((point.value - minVal) / stepSize);

    if (colorBuckets.length === bucketIndex) {
      bucketIndex -= 1;
    }

    var pointRangeObj = {
      maxRange: colorBuckets[bucketIndex].max,
      minRange: colorBuckets[bucketIndex].min,
      pointValue: point.value
    };

    if (!checkPointInRange(pointRangeObj) && bucketIndex !== 0) {
      bucketIndex -= 1;
    }

    point.color = colorBuckets[bucketIndex].color;
    return point;
  });
  return newSeriesData;
}

function checkPointInRange(_ref2) {
  var maxRange = _ref2.maxRange,
      minRange = _ref2.minRange,
      pointValue = _ref2.pointValue;
  return pointValue >= minRange && pointValue <= maxRange;
}

var concatenateArrays = function concatenateArrays(previousSeries, currentSeries) {
  return previousSeries.concat(currentSeries);
};

function heatmapChartData(seriesData) {
  var yCategories = [];
  var xCategories = [];
  var keysForValidation = [];

  _argumentContracts.default.assertArrayOf(seriesData, _seriesData.default, 'chartData');

  if (seriesData[0].data) {
    keysForValidation = seriesData[0].data.map(function (item) {
      return item.key;
    });
  }

  var series = seriesData.map(function (series, seriesIndex) {
    if (seriesData.filter(function (searchSeries) {
      return searchSeries.name === series.name;
    }).length > 1) {
      throw new TypeError("chartData must have unique series.name. Provided value: ".concat(JSON.stringify(series)));
    }

    yCategories.push(series.name);
    return series.data.map(function (dataPoint, dataPointIndex) {
      if (series.data.filter(function (searchPointData) {
        return searchPointData.key === dataPoint.key;
      }).length > 1) {
        throw new TypeError("chartData must have unique series.data.key. Provided value: ".concat(JSON.stringify(dataPoint)));
      }

      if (keysForValidation.indexOf(dataPoint.key) < 0) {
        throw new TypeError("each chartData must have equals series.data.key. Provided value: ".concat(JSON.stringify(dataPoint)));
      }

      if (xCategories.indexOf(dataPoint.key) === -1) {
        xCategories.push(dataPoint.key);
      }

      return {
        /* eslint-disable id-length */
        x: dataPointIndex,
        y: seriesIndex,

        /* eslint-enable id-length */
        value: dataPoint.value,
        name: dataPoint.key
      };
    });
  }).reduce(concatenateArrays);
  return {
    categories: {
      yAxis: yCategories,
      xAxis: xCategories
    },
    series: series
  };
}

var MwChartHeatmap =
/*#__PURE__*/
function () {
  /**
   * Create a new Heatmap Chart
   * @param {string|HTMLElement} renderTarget - The id of, or the HTMLElement for, the element to render into. Note: this element will be emptied!
   */
  function MwChartHeatmap(renderTarget) {
    (0, _classCallCheck2.default)(this, MwChartHeatmap);

    if (!renderTarget) {
      throw new TypeError('renderTarget is required.');
    }

    this.__chart = null;
    this.__renderTarget = renderTarget;
  }
  /**
   * Set the chart data to be rendered
   * @param {Array<SeriesData>} chartData - The data to be rendered to the chart
   * @returns {undefined}
   */


  (0, _createClass2.default)(MwChartHeatmap, [{
    key: "setChartData",
    value: function setChartData(chartData) {
      this.__heatmapChartData = heatmapChartData(chartData);
    }
    /**
     * Set the visualization options for the chart
     * @param {MwChartHeatmapOptions} changedChartOptions - The visualization options for the chart
     * @returns {undefined}
     */

  }, {
    key: "setChartOptions",
    value: function setChartOptions(changedChartOptions) {
      this.__chartOptions = (0, _coerce.default)(changedChartOptions, _mwChartHeatmapOptions.default, "chartOptions must be a valid MwChartHeatmapOptions object. Provided value: ".concat(JSON.stringify(changedChartOptions)));
    }
    /**
     * Render the chart to the renderTarget passed in the constructor
     * @returns {undefined}
     */

  }, {
    key: "render",
    value: function render() {
      try {
        this.error = false;
        var safeHighchartOptions = this.__chartOptions;
        var highchartData = this.__heatmapChartData;
        var safeSeriesColor = safeHighchartOptions.seriesColor;
        var colorBuckets = (0, _getHeatmapGradientColorBuckets.getHeatmapGradientColorBuckets)({
          seriesData: highchartData.series,
          seriesColor: safeSeriesColor
        });
        var colorGradientHighchartData = addColorToChartData({
          seriesData: highchartData.series,
          colorBuckets: colorBuckets
        });
        var safeBaseColor = colorBuckets[0].color;
        var resolvedXAxisLabelFormatter;

        if (typeof safeHighchartOptions.xAxisLabelFormatter === 'string') {
          resolvedXAxisLabelFormatter = (0, _axisLabelFormatters.getFormatter)(safeHighchartOptions.xAxisLabelFormatter);
        } else {
          resolvedXAxisLabelFormatter = safeHighchartOptions.xAxisLabelFormatter;
        }

        var safeXAxisLabelFormatter = function safeXAxisLabelFormatter() {
          var options = new _axisLabelFormatterOptions.default({
            /* eslint-disable no-invalid-this */
            isFirst: this.isFirst,
            isLast: this.isLast,
            value: this.value
            /* eslint-enable no-invalid-this */

          });
          return resolvedXAxisLabelFormatter(options);
        };

        var resolvedYAxisLabelFormatter;

        if (typeof safeHighchartOptions.yAxisLabelFormatter === 'string') {
          resolvedYAxisLabelFormatter = (0, _axisLabelFormatters.getFormatter)(safeHighchartOptions.yAxisLabelFormatter);
        } else {
          resolvedYAxisLabelFormatter = safeHighchartOptions.yAxisLabelFormatter;
        }

        var safeYAxisLabelFormatter = function safeYAxisLabelFormatter() {
          var options = new _axisLabelFormatterOptions.default({
            /* eslint-disable no-invalid-this */
            isFirst: this.isFirst,
            isLast: this.isLast,
            value: this.value
            /* eslint-enable no-invalid-this */

          });
          return resolvedYAxisLabelFormatter(options);
        };

        var safeDataLabelFormatter = function safeDataLabelFormatter() {
          var options = new _mwChartHeatmapLabelFormatterOptions.default({
            /* eslint-disable no-invalid-this */
            key: this.key,
            seriesName: this.point.series.yAxis.categories[this.point.y],
            seriesIndex: this.point.y,
            value: this.point.value
            /* eslint-enable no-invalid-this */

          });
          return safeHighchartOptions.dataLabelFormatter(options);
        };

        var safeTooltipFormatter;
        var enableTooltip = false;

        if (safeHighchartOptions.tooltipFormatter) {
          enableTooltip = true;

          safeTooltipFormatter = function safeTooltipFormatter() {
            /* eslint-disable no-invalid-this */
            var options = new _mwChartHeatmapTooltipOptions.default({
              point: this.point
            });
            /* eslint-enable no-invalid-this */

            return safeHighchartOptions.tooltipFormatter(options);
          };
        }

        var safeOnPointClick;
        var safeCursorStyle = _styles.CURSOR_DEFAULT;

        if (safeHighchartOptions.onPointClick) {
          safeCursorStyle = _styles.CURSOR_POINTER;

          safeOnPointClick = function safeOnPointClick(event) {
            var options = new _mwChartHeatmapClickOptions.default(event);
            return safeHighchartOptions.onPointClick(options);
          };
        }

        var chartOptions = {
          credits: {
            enabled: false
          },
          chart: {
            renderTo: this.__renderTarget,
            type: 'heatmap',
            style: {
              fontFamily: _styles.FONT_FAMILY
            }
          },
          colorAxis: {
            min: 0,
            minColor: safeBaseColor,
            maxColor: safeSeriesColor,
            labels: {
              style: {
                color: _styles.LEGEND_LABEL_FONT_COLOR,
                fontSize: _styles.LEGEND_LABEL_FONT_SIZE,
                fontWeight: _styles.LEGEND_LABEL_FONT_WEIGHT
              },
              formatter: DEFAULT_LEGEND_LABEL_FORMATTER
            }
          },
          legend: {
            enabled: !safeHighchartOptions.hideLegend
          },
          plotOptions: {
            heatmap: {
              animation: safeHighchartOptions.animate,
              dataLabels: {
                color: _styles.DEFAULT_DATALABEL_COLOR,
                enabled: true,
                formatter: safeDataLabelFormatter
              },
              cursor: safeCursorStyle,
              events: {
                click: safeOnPointClick
              }
            }
          },
          title: {
            text: ''
          },
          series: [{
            name: '',
            data: colorGradientHighchartData
          }],
          xAxis: {
            gridLineWidth: 0,
            lineWidth: 0,
            labels: {
              formatter: safeXAxisLabelFormatter,
              style: {
                color: _styles.AXIS_LABEL_FONT_COLOR
              }
            },
            tickWidth: 0,
            categories: highchartData.categories.xAxis
          },
          yAxis: {
            gridLineWidth: 0,
            lineWidth: 0,
            labels: {
              formatter: safeYAxisLabelFormatter,
              style: {
                color: _styles.AXIS_LABEL_FONT_COLOR
              }
            },
            title: {
              style: {
                color: _styles.AXIS_LABEL_FONT_COLOR
              }
            },
            tickWidth: 0,
            categories: highchartData.categories.yAxis
          },
          tooltip: {
            enabled: enableTooltip,
            formatter: safeTooltipFormatter,
            useHTML: true
          }
        };
        this.__chart = _highcharts.default.chart(this.__renderTarget, chartOptions);
      } catch (error) {
        this.error = true;

        _logger.default.error('Chart failed to render.', error);

        this.__chartOptions.onError(error);
      }
    }
  }]);
  return MwChartHeatmap;
}();

exports.default = MwChartHeatmap;